import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Button } from 'components/Atom/Button';

const ErrorFallback = () => {
  const handlePageRefresh = () => {
    window.location.reload();
  };
  return (
    <div className='text-red-500 w-screen h-screen flex flex-col justify-center items-center' role='alert'>
      <h2 className='text-lg font-semibold ' style={{ color: 'rgb(31 41 55)' }}>
        Oops, something went wrong :{'( '}
      </h2>
      <Button onClick={handlePageRefresh}>Refresh</Button>
    </div>
  );
};

const CustomErrorBoundary = ({ children }) => {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};

export default CustomErrorBoundary;
